import React from "react";
import "./OurServices.css";

const OurServices = () => {
  return (
    <div className="our-services">
      <div className="our-services1">
        <h1>Our Services</h1>
      </div>
    </div>
  );
};

export default OurServices;
